import { SkuSearchResult } from './view-models/sku-search-result';

export class TableRow {
  constructor(
    public id: number,
    public skuDetails: SkuSearchResult,
    public feedbackReviewPending: boolean,
    public totalSkuSize: number,
    public lastSeenPrice: number
  ) {}
}
